import { render } from "./Presentacion.vue?vue&type=template&id=781c7ee9&scoped=true"
import script from "./Presentacion.vue?vue&type=script&lang=js"
export * from "./Presentacion.vue?vue&type=script&lang=js"

import "./Presentacion.vue?vue&type=style&index=0&id=781c7ee9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Oscar Daniel\\Desktop\\X LAUCHER\\TRABAJANDO\\05 - VUE\\Ejercio 2\\pasteleria-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781c7ee9"]])

export default __exports__